import * as Sentry from '@sentry/react'

const PRODUCTION_DOMAIN = 'websdk.demos.scandit.com'
const hostname = window.location.hostname
const isProduction = hostname === PRODUCTION_DOMAIN
const isStaging = !isProduction && hostname.includes('.demos.scandit.com')
const environment = isProduction ? 'production' : isStaging ? 'staging' : 'development'

Sentry.init({
  dsn: 'https://91140ab87645441483ce25e264d738ae@sentry.scandit.io/18',
  release: `${PRODUCTION_DOMAIN}@${SCANDIT_SDK_VERSION}`,
  environment,
  // Only enable Sentry in staging and production
  enabled: isProduction || isStaging,
  
  // Adjust sampling rates based on environment
  tracesSampleRate: isProduction ? 0.2 : 1.0,
  replaysSessionSampleRate: isProduction ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [PRODUCTION_DOMAIN, /\.demos\.scandit\.com$/],
  beforeSend: function (event, hint) {
    const exception = hint?.originalException as { name?: string; message?: string }
    if (exception !== null && exception?.name === 'ScanditEngineError') {
      event.fingerprint = ['{{ default }}', exception.name, exception.message ?? '']
    }
    return event
  },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
})

window.onunhandledrejection = function (event) {
  // Only report to Sentry in staging and production
  if (!isProduction && !isStaging) {
    console.warn('Sentry disabled in development. Error:', event)
    return
  }

  if (event.reason) {
    if (typeof event.reason == 'string' || event.reason instanceof String) {
      console.error(event.reason)
    } else {
      console.error(event.reason.name)
      console.error(event.reason.message)
      console.error(event.reason.stack)
    }
    Sentry.captureException(event.reason)
  } else {
    console.error(event)
    Sentry.captureException(event)
  }

  if (typeof event.preventDefault === 'function') {
    event.preventDefault()
  }
}

export default Sentry
